import * as R from 'ramda';

function toSnakeCase(text: string): string {
  return R.replace(' ', '_', text.toLowerCase());
}

export default toSnakeCase;
